import React, { useState } from 'react';
import { translate } from '../Services/translation';
import InputCheckbox from './InputCheckbox';
import InputTextArea from './InputTextArea';
import { boolean, object, string } from 'yup';
import { postInquire } from '../Services/CampaignContactUs.service';
import { googleAnalytics } from '../Services/googleAnalytics';

const formValidationSchema = object().shape({
  selectedStore: string()
    .required(translate(`validation.required`))
    .notOneOf(['none'], translate(`validation.required`)),
  name: string().required(translate(`validation.required`)),
  emailAddress: string().required(translate(`validation.required`)),
  phoneNumber: string().required(translate(`validation.required`)),
  hasAcceptedTac: boolean()
    .required(translate(`validation.checkrequired`))
    .oneOf([true], translate(`validation.checkrequired`)),
});

const CampaignContactUsBlock = ({
  header,
  text,
  tacText,
  id,
  channelId,
  organizationsAsString,
  campaignId,
}) => {
  const organizations = JSON.parse(organizationsAsString);
  const [selectedCity, setSelectedCity] = useState('none');
  const [selectedStore, setSelectedStore] = useState('none');
  const [name, setName] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [contactViaEmail, setContactViaEmail] = useState(false);
  const [contactViaPhone, setContactViaPhone] = useState(false);
  const [messageToReseller, setMessageToReseller] = useState(null);
  const [hasAcceptedTac, setHasAcceptedTac] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(null);
  const [showErrorMessage, setShowErrorMessage] = useState(null);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    try {
      const data = await formValidationSchema.validate({
        name,
        phoneNumber,
        emailAddress,
        contactViaPhone,
        contactViaEmail,
        messageToReseller,
        hasAcceptedTac,
        selectedStore,
        channelId,
        blockId: id,
      });
      if (await postInquire(data)) {
        setShowSuccessMessage(true);
        googleAnalytics({
          "event": 'campaignBlockContact',
          "formType": 'campaign form',
          "brenderup_campaign_id": campaignId,
          "resellerName": organizations
          .find((x) => x.city == selectedCity)
          ?.organizations.find(x => x.id == selectedStore)?.shopName,
          "resellerId": organizations
          .find((x) => x.city == selectedCity)
          ?.organizations.find(x => x.id == selectedStore)?.dealerERPID,
          "email": emailAddress,
          'email_contact': contactViaEmail,
          'telephone_contact ': contactViaPhone,
          "resellerCity": selectedCity
        })
      } else {
        setShowErrorMessage(true);
        setTimeout(() => {
          setShowErrorMessage(false);
        }, 5000);
      }
    } catch (e) {
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
      }, 5000);
    }
  };
  
  return (
    <form className="campaign-contact-us" onSubmit={onSubmit}>
      <div className="row">
        <div className="columns small-12 medium-6 large-4">
          <h1>{header}</h1>
          <div dangerouslySetInnerHTML={{ __html: text }}></div>
        </div>
        {!showSuccessMessage && (
          <>
            <div className="columns small-12 medium-6 large-4">
              <div className="form__inputGroup">
                <select
                  className="form__input"
                  onChange={(ev) => setSelectedCity(ev.target.value)}
                  value={selectedCity}
                >
                  <option disabled value="none">
                    {translate('campaigncontactus.selectcity')}
                  </option>
                  {organizations && organizations.map((x) => (
                    <option key={x.city} value={x.city}>
                      {x.city}
                    </option>
                  ))}
                </select>
              </div>
              <div
                className={`form__inputGroup ${
                  selectedCity == 'none'
                    ? 'campaign-contact-us__form-group--close'
                    : ''
                }`}
              >
                <select
                  className="form__input"
                  onChange={(ev) => setSelectedStore(ev.target.value)}
                  value={selectedStore}
                >
                  <option disabled value="none">
                    {translate('campaigncontactus.selectstore')}
                  </option>
                  {organizations && organizations
                    .find((x) => x.city == selectedCity)
                    ?.organizations.map((x) => (
                      <option key={x.id} value={x.id}>
                        {x.shopName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="form__inputGroup">
                <input
                  className="form__input"
                  placeholder={translate('campaigncontactus.yourname')}
                  onChange={(ev) => setName(ev.target.value)}
                />
              </div>
              <div className="form__inputGroup">
                <input
                  className="form__input"
                  placeholder={translate('campaigncontactus.youremail')}
                  type="email"
                  onChange={(ev) => setEmailAddress(ev.target.value)}
                />
              </div>
              <div className="form__inputGroup">
                <input
                  className="form__input"
                  placeholder={translate('campaigncontactus.yourphone')}
                  type="tel"
                  onChange={(ev) => setPhoneNumber(ev.target.value)}
                />
              </div>
            </div>
            <div className="columns small-12 medium-6 large-4">
              <div className="form__inputGroup">
                <p>{translate('campaigncontactus.wanttobecontactedvia')}</p>
                <div className="campaign-contact-us__addresses--contact">
                  <InputCheckbox
                    name="contactViaEmail"
                    title={translate('campaigncontactus.email')}
                    className="contact-check"
                    onChange={(ev) =>
                      setContactViaEmail(ev.target.value == 'on')
                    }
                  />
                  <InputCheckbox
                    name="contactViaPhone"
                    title={translate('campaigncontactus.phone')}
                    className="contact-check"
                    onChange={(ev) =>
                      setContactViaPhone(ev.target.value == 'on')
                    }
                  />
                </div>
              </div>
              <div className="form__inputGroup">
                <InputTextArea
                  placeholder={translate('campaigncontactus.messagetoreseller')}
                  onChange={(ev) => setMessageToReseller(ev.target.value)}
                />
              </div>
              <div className="form__inputGroup">
                <div className="input-wrapper">
                  <InputCheckbox
                    name="approveIntegrityPolicy"
                    htmlTitle={tacText}
                    onChange={(ev) => setHasAcceptedTac(ev.target.checked)}
                  />
                </div>
              </div>
              <button
                className={`campaign-contact-us__submit ${
                  !hasAcceptedTac ? 'campaign-contact-us__button--disabled' : ''
                }`}
                type="submit"
                disabled={!hasAcceptedTac}
              >
                {translate('campaigncontactus.send')}
              </button>
              {showErrorMessage && (
                <p>{translate('campaigncontactus.submiterror')}</p>
              )}
            </div>
          </>
        )}
        {showSuccessMessage && (
          <div className="columns small-12 medium-6 large-8 text-center">
            <h2>{translate('campaigncontactus.successheader')}</h2>
            <p>{translate('campaigncontactus.successbody')}</p>
          </div>
        )}
      </div>
    </form>
  );
};

export default CampaignContactUsBlock;
